import React, { useState, useEffect } from 'react';
import './App.css';
import GorbLogo from './content/logo.png';
import DashboardPage from './pages/DashboardPage';

const VerificationPage = () => {
  const [code, setCode] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  // Проверяем localStorage при загрузке компонента
  useEffect(() => {
    const savedVerification = localStorage.getItem('isVerified');
    if (savedVerification === 'true') {
      setIsVerified(true);
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (code === process.env.REACT_APP_PASSWORD) {
      setIsVerified(true);
      // Сохраняем состояние авторизации в localStorage
      localStorage.setItem('isVerified', 'true');
    } else {
      alert('Неверный мастер пароль');
    }
  };

  return (
    <>
      {isVerified ? (
        <DashboardPage />
      ) : (
        <div className="verification-page">
          <img src={GorbLogo} alt="Logo" className="rounded-image" />
          <div className="phone-number">
            <p>Админ панель бота</p>
          </div>
          <div className="info-text">
            <p>Для доступа введите свой мастер пароль</p>
          </div>
          <form onSubmit={handleSubmit} className="code-form">
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Мастер пароль"
              className="code-input"
            />
            <button type="submit" className="submit-button">Войти</button>
          </form>
        </div>
      )}
    </>
  );
};

export default VerificationPage;